import type { ComponentType } from 'react'
import { Ellipsis, MessageCircle, UserRound, Users } from 'lucide-react'
import {
    ClaudeIcon,
    FacebookIcon,
    GeminiIcon,
    InstagramIcon,
    LinkedInIcon,
    OpenAiIcon,
    RedditIcon,
    XIcon,
} from '@duck/ui'
import { UserService } from '@duck/api-definitions'
import type { TranslationKey } from '@/modules/i18n/types'

type DiscoverySourceOption = {
    value: UserService.DiscoverySource
    labelKey: TranslationKey
    Icon: ComponentType<{ size?: number | string; className?: string }>
}

export const DISCOVERY_SOURCE_GROUPS: { labelKey: TranslationKey; options: DiscoverySourceOption[] }[] = [
    {
        labelKey: 'personalInfo.discoverySourceGroups.ai',
        options: [
            { value: UserService.DiscoverySource.Claude, labelKey: 'personalInfo.discoverySourceOptions.claude', Icon: ClaudeIcon },
            { value: UserService.DiscoverySource.Gemini, labelKey: 'personalInfo.discoverySourceOptions.gemini', Icon: GeminiIcon },
            { value: UserService.DiscoverySource.Gpt, labelKey: 'personalInfo.discoverySourceOptions.gpt', Icon: OpenAiIcon },
        ],
    },
    {
        labelKey: 'personalInfo.discoverySourceGroups.socials',
        options: [
            { value: UserService.DiscoverySource.Facebook, labelKey: 'personalInfo.discoverySourceOptions.facebook', Icon: FacebookIcon },
            { value: UserService.DiscoverySource.Instagram, labelKey: 'personalInfo.discoverySourceOptions.instagram', Icon: InstagramIcon },
            { value: UserService.DiscoverySource.Linkedin, labelKey: 'personalInfo.discoverySourceOptions.linkedin', Icon: LinkedInIcon },
            { value: UserService.DiscoverySource.X, labelKey: 'personalInfo.discoverySourceOptions.x', Icon: XIcon },
            { value: UserService.DiscoverySource.Reddit, labelKey: 'personalInfo.discoverySourceOptions.reddit', Icon: RedditIcon },
        ],
    },
    {
        labelKey: 'personalInfo.discoverySourceGroups.other',
        options: [
            { value: UserService.DiscoverySource.Friend, labelKey: 'personalInfo.discoverySourceOptions.friend', Icon: UserRound },
            { value: UserService.DiscoverySource.Colleague, labelKey: 'personalInfo.discoverySourceOptions.colleague', Icon: Users },
            { value: UserService.DiscoverySource.WordOfMouth, labelKey: 'personalInfo.discoverySourceOptions.wordOfMouth', Icon: MessageCircle },
            { value: UserService.DiscoverySource.Other, labelKey: 'personalInfo.discoverySourceOptions.other', Icon: Ellipsis },
        ],
    },
]

export const findDiscoverySourceOption = (value: UserService.DiscoverySource) =>
    DISCOVERY_SOURCE_GROUPS.flatMap((group) => group.options).find((option) => option.value === value)
